// extracted by mini-css-extract-plugin
export default {"card":"GRLinkCard_card__zXJOJ","btn":"GRLinkCard_btn__g6kPQ","soft_buyInfos":"GRLinkCard_soft_buyInfos__BjXtz"};